// extracted by mini-css-extract-plugin
export default {"artistMedia":"Media_artistMedia__VEnGB","title":"Media_title__Z-Wkg","mediaContainer":"Media_mediaContainer__IE1KI","loadMore":"Media_loadMore__yT5dP"};